// extracted by mini-css-extract-plugin
export default {"currentNavHeaderContainer":"CurrentNavHeader_currentNavHeaderContainer__qANeP","title":"CurrentNavHeader_title__sREcQ","circleContainer":"CurrentNavHeader_circleContainer__9pgFC"};